
import { BaseBackgroundEffect } from '@/render/background/BaseBackgroundEffect';
import { BackgroundContext } from '@/render/background/BackgroundEffect';

export class AuroraBaseBackground extends BaseBackgroundEffect {
    public render(bc: BackgroundContext): void {
        const { ctx, width, height, time, config } = bc;
        const speed = config.backgroundSpeed || 1.0;
        
        ctx.fillStyle = config.backgroundTertiaryColor;
        ctx.fillRect(0, 0, width, height);

        const lanes = 3;
        for (let i = 0; i < lanes; i++) {
            const laneTime = time * speed + i * 10;
            const grad = ctx.createLinearGradient(0, 0, width, height);
            
            const color = i === 0 ? this.getPrimaryColor(bc) : (i === 1 ? this.getSecondaryColor(bc) : this.getTertiaryColor(bc));
            
            grad.addColorStop(0, 'transparent');
            grad.addColorStop(0.5, color);
            grad.addColorStop(1, 'transparent');

            ctx.save();
            ctx.globalAlpha = 0.4;
            ctx.globalCompositeOperation = 'screen';
            
            ctx.beginPath();
            const yOffset = height * 0.3 * Math.sin(laneTime * 0.5);
            ctx.moveTo(0, height * 0.5 + yOffset);
            
            for (let x = 0; x <= width; x += 50) {
                const wave = Math.sin(x * 0.002 + laneTime) * 100 + Math.cos(x * 0.005 - laneTime * 0.8) * 50;
                ctx.lineTo(x, height * 0.5 + yOffset + wave);
            }
            
            ctx.lineTo(width, height);
            ctx.lineTo(0, height);
            ctx.closePath();
            
            ctx.fillStyle = grad;
            ctx.fill();
            ctx.restore();
        }
    }
}
